import { nanoid } from 'nanoid';

export default function (element, data) {
    const id = nanoid();
    const accordion = data.accordion || "none";
    var initialState = (data.state || "closed") === "open";
    const toggle = element.querySelector(".collapse-toggle");
    const wrap = element.querySelector(".collapse-wrap");
    const content = element.querySelector(".collapse-content");

    // Проверяем, есть ли внутри активные ссылки
    var hasActiveChild = element.querySelector('.is_current') !== null;
    if (hasActiveChild) {
        initialState = true;
    } 

    let isOpen = initialState;

    toggle.addEventListener("click", function () {
        if (!isOpen) {
            open();
        } else {
            close();
        }
    });

    wrap.addEventListener("transitionend", function () {
        if (isOpen) {
            wrap.style.height = "auto";
            wrap.style.overflow = "visible";
        }
    });

    window.addEventListener("collapseOpen", function (event) {
        if (event.detail.accordion && event.detail.accordion !== "none" && event.detail.accordion === accordion && event.detail.id !== id) {
            close();
        }
    });

    if (initialState) {
        open();
    } else {
        close();
    }

    function open() {
        if (!isOpen) {
            isOpen = true;
            const height = content.offsetHeight;

            const computedStyle = getComputedStyle(content);
            const marginTop = parseFloat(computedStyle.marginTop);

            const totalHeight = height + marginTop;

            element.classList.add("collapse-open");
            wrap.style.height = totalHeight + "px";
            wrap.style.overflow = "hidden";

            window.dispatchEvent(new CustomEvent("collapseOpen", {
                detail: {
                    id: id,
                    accordion: accordion
                }
            }));
        } else {
            wrap.style.height = "auto";
            wrap.style.overflow = "visible";
        }
    }

    function close() {
        wrap.style.overflow = "hidden";

        if (isOpen) {
            isOpen = false;
            const height = content.offsetHeight;

            element.classList.remove("collapse-open");
            wrap.style.height = height + "px";
            setTimeout(function () {
                wrap.style.height = "0px";
            }, 1);
        } else {
            wrap.style.height = "0px";
        }
    }
}
